export const financialTips = [
    {
      tip: "Early repayment of your loan can help improve your credit score and unlock higher loan amounts in the future!",
    },
    {
      tip: "Set a reminder 2 days before your EMI due date to ensure timely payments and maintain a good repayment record.",
    },
    {
      tip: "Regular and timely loan repayments can help you become eligible for lower interest rates on your next loan.",
    },
    {
      tip: "Maintaining a good credit score through timely EMI payments can help you get instant loan approvals when needed.",
    },
    {
      tip: "Plan your EMIs around your salary date to ensure smooth repayments and avoid any late payment charges.",
    },
    {
      tip: "Refer your friends to earn rewards and build a strong relationship with us for better loan benefits.",
    },
    {
      tip: "Keep your KYC documents updated to ensure quick processing of future loan requests.",
    },
    {
      tip: "Download our mobile app to track your loan status and make instant repayments anytime, anywhere.",
    },
    {
      tip: "Repay your current loan successfully to become eligible for higher loan amounts and special offers.",
    },
  ];